import { FC } from "react";
import css from './index.module.css';

interface Tabs {
  active?: number
  setActive?: any
  isFull?: boolean
  vertical?: boolean
}

const Tabs:FC<Tabs> = ({ active, setActive }) => {
  return (
    <div className={css.sections}>
      <div className={`${css.section} ${active === 0 ? css.active : ''}`} onClick={() => setActive(0)}>Мои заказы</div>
      <div className={`${css.section} ${(active === 3 || active === 4) ? css.active : ''}`} onClick={() => setActive(3)}>Адреса</div>
      <div className={`${css.section} ${active === 1 ? css.active : ''}`} onClick={() => setActive(1)}>Настройки</div>
      <div className={`${css.section} ${active === 2 ? css.active : ''}`} onClick={() => setActive(2)}>О нас</div>
    </div>
  );
};

export default Tabs;